// extracted by mini-css-extract-plugin
export default {"blobs":"blobs_blobs__VZdxM"};